import onBeforeSynchronizeElement from './on-before-synchronize-element';
import onBeforeSetElementAttribute from './on-before-set-element-attribute';
import onBeforeReplaceElement from './on-before-replace-element';

export default {
  onBeforeSynchronizeElement,
  onBeforeSetElementAttribute,
  onBeforeReplaceElement,
};
